// extracted by mini-css-extract-plugin
export var alternativeBillingAddress = "component-module--alternativeBillingAddress--ac70c";
export var hidden = "component-module--hidden--d6cfe";
export var priceInformation = "component-module--priceInformation--af06b";
export var priceInformationHeadline = "component-module--priceInformationHeadline--70f0a";